import { useCallback } from 'react';
import { useSelector } from 'react-redux';
const useSelectorWithProps = (selector, props) => {
    const selectorWithMappedProps = useCallback((state) => selector(state, props), [selector, props]);
    return useSelector(selectorWithMappedProps);
};
export default useSelectorWithProps;
